import { render, staticRenderFns } from "./FieldForm.vue?vue&type=template&id=c2632b28&scoped=true"
import script from "./FieldForm.vue?vue&type=script&lang=js"
export * from "./FieldForm.vue?vue&type=script&lang=js"
import style0 from "./FieldForm.vue?vue&type=style&index=0&id=c2632b28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2632b28",
  null
  
)

export default component.exports